module.exports = __webpack_public_path__ + "static/media/help.ce218969.svg";